module.exports = __webpack_public_path__ + "src/images/srm-university.63134f05a1b66322e544d7fc49239a9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/srm-university.jpg
// module id = 112
// module chunks = 0